import React from "react";
import { useRef, useEffect, useState } from "react";
import { NavLink } from "react-router-dom";
import "bootstrap-icons/font/bootstrap-icons.css";

import "./NavSideBar.css";
const NavSideBar = ({ isOpen, toggleSidebar }) => {
  const [activeItem, setActiveItem] = useState(null);
  const handleItemClick = (index) => {
    setActiveItem(index === activeItem ? null : index);
    if (!isOpen) {
      toggleSidebar(true);
      return;
    }
  };
  const handleSubItemClick = () => {
    if (window.innerWidth <= 991) {
      toggleSidebar(false);
    }
  };
  return (
    <div className={` ${isOpen ? "" : "side-closed"}`}>
      <div className="sidebar">
        <div className="menu">
          <ul className="nav flex-column list">
            <li className={`nav-item ${activeItem === 0 ? "active" : ""}`}>
              <a
                className="nav-link  menu-top  menu-toggle "
                aria-current="page"
                onClick={() => handleItemClick(0)}
              >
                <div className="sidebarIcon ">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 24 24"
                    className="feather feather-monitor"
                  >
                    <rect
                      x="2"
                      y="3"
                      width="20"
                      height="14"
                      rx="2"
                      ry="2"
                    ></rect>
                    <line x1="8" y1="21" x2="16" y2="21"></line>
                    <line x1="12" y1="17" x2="12" y2="21"></line>
                  </svg>
                </div>
                <span className="hide-menu">Dashboard</span>
              </a>
              <ul className="ml-menu">
                <li>
                  <NavLink
                    to="dashboard"
                    onClick={() => {
                      handleSubItemClick();
                    }}
                  >
                    Dashboard
                  </NavLink>
                </li>
              </ul>
            </li>
            <li className={`nav-item ${activeItem === 1 ? "active" : ""}`}>
              <a
                className="nav-link  menu-top  menu-toggle "
                aria-current="page"
                onClick={() => handleItemClick(1)}
              >
                <div className="sidebarIcon">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="18"
                    height="18"
                    viewBox="0 0 24 24"
                    className="feather feather-calendar"
                  >
                    <rect x="3" y="4" width="18" height="18" rx="2" ry="2" />
                    <line x1="16" y1="2" x2="16" y2="6" />
                    <line x1="8" y1="2" x2="8" y2="6" />
                    <line x1="3" y1="10" x2="21" y2="10" />
                  </svg>
                </div>
                <span>Appointments</span>
              </a>
              <ul className="ml-menu">
                <li>
                  <NavLink
                    to="appointments-manegment"
                    onClick={() => {
                      handleSubItemClick();
                    }}
                  >
                    Appointments Management
                  </NavLink>
                </li>
                <li>
                  <NavLink
                    to="add-appointment"
                    onClick={() => {
                      handleSubItemClick();
                    }}
                  >
                    Add Appointment
                  </NavLink>
                </li>
              </ul>
            </li>

            <li className={`nav-item ${activeItem === 2 ? "active" : ""}`}>
              <a
                className="nav-link  menu-top  menu-toggle "
                aria-current="page"
                onClick={() => handleItemClick(2)}
              >
                <div className="sidebarIcon">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 24 24"
                    className="feather feather-users"
                  >
                    <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>
                    <circle cx="9" cy="7" r="4"></circle>
                    <path d="M23 21v-2a4 4 0 0 0-3-3.87"></path>
                    <path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
                  </svg>
                </div>
                <span>Staff</span>
              </a>
              <ul className="ml-menu">
                <li>
                  <NavLink
                    to="staff"
                    onClick={() => {
                      handleSubItemClick();
                    }}
                  >
                    All staff
                  </NavLink>
                </li>
                <li>
                  <NavLink
                    to="staff-availabilty"
                    onClick={() => {
                      handleSubItemClick();
                    }}
                  >
                    Staff Availabilty
                  </NavLink>
                </li>
                <li>
                  <NavLink
                    to="staff-unavailabilty"
                    onClick={() => {
                      handleSubItemClick();
                    }}
                  >
                    Staff Unavailabilty
                  </NavLink>
                </li>
              </ul>
            </li>
            <li className={`nav-item ${activeItem === 3 ? "active" : ""}`}>
              <a
                className="nav-link  menu-top  menu-toggle "
                aria-current="page"
                onClick={() => handleItemClick(3)}
              >
                <div className="sidebarIcon">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                    <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
                    <circle cx="12" cy="7" r="4"></circle>
                  </svg>
                </div>
                <span>Customers</span>
              </a>
              <ul className="ml-menu">
                <li>
                  <NavLink
                    to="customers"
                    onClick={() => {
                      handleSubItemClick();
                    }}
                  >
                    All Customers
                  </NavLink>
                </li>
                <li>
                  <NavLink
                    to="add-customer"
                    onClick={() => {
                      handleSubItemClick();
                    }}
                  >
                    Add Customer
                  </NavLink>
                </li>
              </ul>
            </li>
            <li className={`nav-item ${activeItem === 4 ? "active" : ""}`}>
              <a
                className="nav-link  menu-top  menu-toggle "
                aria-current="page"
                onClick={() => handleItemClick(4)}
              >
                <div className="sidebarIcon">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="18"
                    height="18"
                    viewBox="0 0 24 24"
                    className="feather feather-list"
                  >
                    <line x1="8" y1="6" x2="21" y2="6" />
                    <line x1="8" y1="12" x2="21" y2="12" />
                    <line x1="8" y1="18" x2="21" y2="18" />
                    <line x1="3" y1="6" x2="3.01" y2="6" />
                    <line x1="3" y1="12" x2="3.01" y2="12" />
                    <line x1="3" y1="18" x2="3.01" y2="18" />
                  </svg>
                </div>
                <span>Services</span>
              </a>
              <ul className="ml-menu">
                <li>
                  <NavLink
                    to="services"
                    onClick={() => {
                      handleSubItemClick();
                    }}
                  >
                    All Services
                  </NavLink>
                </li>
                <li>
                  <NavLink
                    to="/service-groups"
                    onClick={() => {
                      handleSubItemClick();
                    }}
                  >
                    Service groups
                  </NavLink>
                </li>
                <li>
                  <NavLink
                    to="/staff-service"
                    onClick={() => {
                      handleSubItemClick();
                    }}
                  >
                    Service per staff
                  </NavLink>
                </li>
              </ul>
            </li>
            <li className={`nav-item ${activeItem === 5 ? "active" : ""}`}>
              <NavLink
                to="calendar"
                className="nav-link menu-top"
                onClick={() => {
                  handleItemClick(5);
                  handleSubItemClick();
                }}
              >
                <div className="sidebarIcon">
                  <i class="bi bi-calendar-check"></i>
                </div>
                <span>calendar</span>
              </NavLink>
            </li>

            <li className={`nav-item ${activeItem === 6 ? "active" : ""}`}>
              <NavLink
                to="settings"
                className="nav-link menu-top"
                onClick={() => {
                  handleItemClick(6);
                  handleSubItemClick();
                }}
              >
                <div className="sidebarIcon">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="18"
                    height="18"
                    viewBox="0 0 24 24"
                    className="main-grid-item-icon"
                    fill="none"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                  >
                    <circle cx="12" cy="12" r="3" />
                    <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-2 2 2 2 0 0 1-2-2v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83 0 2 2 0 0 1 0-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1-2-2 2 2 0 0 1 2-2h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 0-2.83 2 2 0 0 1 2.83 0l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 2-2 2 2 0 0 1 2 2v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 0 2 2 0 0 1 0 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 2 2 2 2 0 0 1-2 2h-.09a1.65 1.65 0 0 0-1.51 1z" />
                  </svg>
                </div>
                <span>Settings</span>{" "}
              </NavLink>
            </li>
          </ul>
        </div>
      </div>{" "}
    </div>
  );
};
export default NavSideBar;
